import { useSelector } from "react-redux";
import { ProjectData } from "../../components/ProjectSelectorWrapper/type";
import { selectActiveProject, selectProjects, selectSpecialInstances } from "./selector";
import { SpecialInstancesResponse } from "../../packages/Api/data/instances/types";

export const useActiveProject = (): ProjectData | undefined => useSelector(selectActiveProject);
export const useProjects = (): ProjectData[] | undefined => useSelector(selectProjects);
export const useSpecialInstances = (): SpecialInstancesResponse | undefined => useSelector(selectSpecialInstances);
